import { Form } from "antd";
import { useParams } from "react-router";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { TextInput } from "../Text/TextInput";
import { TerminalIdGenerator } from "./TerminalIdGenerator";

export const TerminalIdGeneratorField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    const { id } = useParams();

    return (
        <Form.Item noStyle shouldUpdate={() => true}>
            {({ getFieldValue }) => {
                const TERMINAL_PROFILE_ID = getFieldValue("terminalProfileId");
                const SITE_ID = getFieldValue("siteId");

                return !id && TERMINAL_PROFILE_ID && SITE_ID ? (
                    <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
                        <TerminalIdGenerator
                            key={field.name}
                            readOnly={readOnly}
                            terminalProfileId={TERMINAL_PROFILE_ID}
                            siteId={SITE_ID}
                            label={field.translationKeys.label}
                            name={field.name}
                        />
                    </Form.Item>
                ) : (
                    <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
                        <TextInput key={field.name} name={field.name} label={field.translationKeys.label} readOnly />
                    </Form.Item>
                );
            }}
        </Form.Item>
    );
};
